<template>
  <div class="form-input">
    <v-list lines="one">
      <v-list-subheader>{{ item.label }}</v-list-subheader>
      <v-list-item
        v-for="(checkboxItem, index) in item.content"
        :key="`${item.id}-${index}`"
      >
        <template v-slot:default>
          <v-checkbox
            :label="checkboxItem.text"
            :value="`${item.id}-${index}`"
            :disabled="disabled"
            v-model="selected"
          />
        </template>
      </v-list-item>
    </v-list>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, computed, ref, watch } from 'vue'

const props = defineProps({
  item: {
    type: Object,
    required: true,
    // Expected: { id: String|Number, label: String, content: Array<{ text: String }> }
  },
  disabled: Boolean,
  modelValue: {
    type: Array,
    default: () => []
  }
})

const emit = defineEmits(['update:modelValue'])

// Create a local reactive reference to track selections
const selected = ref([...props.modelValue])

// Watch for changes from parent
watch(() => props.modelValue, (newVal) => {
  // Only update if values are different to avoid loops
  if (JSON.stringify(newVal) !== JSON.stringify(selected.value)) {
    selected.value = [...newVal]
  }
}, { deep: true })

// Watch for local changes and emit them
watch(selected, (newVal) => {
  emit('update:modelValue', [...newVal])
}, { deep: true })
</script>